import { atom } from 'recoil';

import type { NodeType } from '../models';

type AddNodeMenuState = {
  anchorEl: HTMLElement | null;
  conditionalAllowed: boolean;
  isOpen: boolean;
  onAdd: ((nodeType: NodeType, edgeType?: 'next' | 'no' | 'yes') => void) | null;
};

export const addNodeMenuState = atom<AddNodeMenuState>({
  key: 'addNodeMenuState',
  default: {
    anchorEl: null,
    isOpen: false,
    onAdd: null,
    conditionalAllowed: true,
  },
});
